import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';
import buildCriteriaQuery from '@/shared/criteria/criterias';

import { IGesDoc } from '@/shared/model/ges-doc.model';

const baseApiUrl = 'api/ges-docs';

export default class GesDocService {
  public find(id: number): Promise<IGesDoc> {
    return new Promise<IGesDoc>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public download(id: number, fileName: string, ext: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios({
        url: `${baseApiUrl}/download/${id}`,
        method: 'GET',
        responseType: 'blob' // important
      })
        .then(function(response) {
          if (!window.navigator.msSaveOrOpenBlob) {
            // BLOB NAVIGATOR
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName + ext);
            document.body.appendChild(link);
            link.click();
          } else {
            // BLOB FOR EXPLORER 11
            const url = window.navigator.msSaveOrOpenBlob(new Blob([response.data]), fileName + ext);
          }
          resolve('success');
        })
        .catch(err => {
          resolve('err: ' + err);
        });
    });
  }

  public clean(id: number, tableRef: string): Promise<IGesDoc> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/clean?id1=${id}&tableRef=${tableRef}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveByCriteria(paginationQuery?: any, criteriaQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}${buildCriteriaQuery(criteriaQuery)}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(function(res) {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IGesDoc): Promise<IGesDoc> {
    return new Promise<IGesDoc>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IGesDoc): Promise<IGesDoc> {
    return new Promise<IGesDoc>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(function(res) {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
